import { Box } from '@material-ui/core';
import React, { FC, useState } from 'react';
import {
  EditButton,
  FormTab,
  Show,
  ShowProps,
  TabbedForm,
  usePermissions,
  useRedirect,
  useShowController,
} from 'react-admin';
import DocumentTitle from '../common/documentTitle/DocumentTitle';
import BlogGeneralTab from './GeneralTab';
import ReplyIcon from '@material-ui/icons/Reply';
import { checkPermission } from '../../helpers/checkPermissions';
import ImagesAssetsTab from './ImagesAssetsTab';

const ShowUser: FC<ShowProps> = (props) => {
  const { permissions } = usePermissions();
  const controllerProps = useShowController<any>(props);
  const id = props.id ? props.id : controllerProps.record?._id;
  const redirect = useRedirect();
  const [state, setState] = useState({
    isBlocked: false,
  });

  const changeStatus = () => {
    setState({ ...state, isBlocked: !state.isBlocked });
  };

  const toList = () => {
    redirect('/blogs');
  };

  return (
    <>
      <DocumentTitle
        core='Blog'
        secondary='Blog'
        purpose={`${controllerProps.record?.title}`}
        appointment={``}
      />
      <Box position='relative'>
        <div className='back-icon'>
          <ReplyIcon onClick={toList} />
        </div>
        <Show
          {...props}
          // hasEdit={checkPermission(permissions, 'User management', 'Update')}
        >
          <TabbedForm className='user-tabs' toolbar={<CustomToolbar />}>
            <FormTab label='General'>
              <BlogGeneralTab
                isBlocked={state.isBlocked}
                changeStatus={changeStatus}
                isShow={true}
              />
            </FormTab>
            <FormTab label='Images Assets'>
              <ImagesAssetsTab
                isBlocked={state.isBlocked}
                changeStatus={changeStatus}
                isShow={true}
              />
            </FormTab>
          </TabbedForm>
        </Show>
      </Box>
    </>
  );
};

const CustomToolbar = () => {
  return <></>;
};

export default ShowUser;
